var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManualsms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.92 94.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.92,5.54l-.21,84.37-40.26-55.85L199.41,2.95l.22.69c.19.64.29,1.26.29,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m195.09.33l-62.59,48.72c-.77.62-1.66.92-2.55.92s-1.77-.3-2.55-.91L64.51,0l130.58.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m197.07,93.9l-.63.22c-.4.14-.82.21-1.26.21l-132.4-.33,42.08-56.53,20.29,15.82c1.44,1.13,3.09,1.7,4.83,1.71,1.67,0,3.32-.59,4.79-1.71l21.15-16.48.31.42,40.84,56.67Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.65,34.81l-40.69,54.62c-.02-.22-.04-.42-.04-.64l.03-11.1h-24.45c-1.93,0-3.5-1.57-3.5-3.5,0-.97.39-1.84,1.03-2.47.63-.64,1.5-1.03,2.47-1.03h24.47l.03-12H23.5c-1.93,0-3.5-1.57-3.5-3.5,0-.97.39-1.84,1.03-2.47.63-.64,1.5-1.03,2.47-1.03h36.51l.04-13H13.5c-1.93,0-3.5-1.57-3.5-3.5,0-.97.39-1.84,1.03-2.47.63-.64,1.5-1.03,2.47-1.03h46.56l.03-12H3.5c-1.93,0-3.5-1.57-3.5-3.5,0-.97.39-1.84,1.03-2.47.63-.64,1.5-1.03,2.47-1.03h56.61l.02-7.5c0-.62.11-1.2.3-1.74l40.22,31.36Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualsms);
export default __webpack_public_path__ + "static/media/Manualsms.f1ff4a5468efcd11aeb05415eb2baf95.svg";
export { ForwardRef as ReactComponent };